"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .fade {\n    &-enter-active, &-exit-active {\n      transition: opacity 0.25s ease-in-out;\n    }\n    &-enter {\n      opacity: 0;\n      &-active {\n        opacity: 1;\n      }\n    }\n    &-exit {\n      opacity: 1;\n      &-active {\n        opacity: 0;\n      }\n    }\n  }\n\n  .fade-up {\n    &-enter-active, &-exit-active {\n      transition: opacity 0.25s ease-in-out, transform 0.25s ease-in-out;\n    }\n    &-enter {\n      opacity: 0;\n      transform: translateY(50px);\n      &-active {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n    &-exit {\n      opacity: 1;\n      transform: translateY(0);\n      &-active {\n        opacity: 0;\n        transform: translateY(-50px);\n      }\n    }\n  }\n\n  .fade-scale {\n    &-enter-active, &-exit-active {\n      transition: opacity 0.25s ease-in-out, transform 0.25s ease-in-out;\n      transform-origin: 50% 300px;\n    }\n    &-enter {\n      opacity: 0;\n      transform: scale(0.98);\n      &-active {\n        opacity: 1;\n        transform: none;\n      }\n    }\n    &-exit {\n      opacity: 1;\n      transform: none;\n      &-active {\n        opacity: 0;\n        transform: scale(0.98);\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransitionGlobalStyle = exports.Transition = void 0;

var react_1 = __importDefault(require("react"));

var react_transition_group_1 = require("react-transition-group");

var styled_components_1 = require("styled-components");

var FALLBACK_DELAY = 1000;

function Transition(_a) {
  var state = _a.state,
      type = _a.type,
      children = _a.children,
      containerProps = _a.containerProps,
      switchProps = _a.switchProps,
      props = __rest(_a, ["state", "type", "children", "containerProps", "switchProps"]);

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(exports.TransitionGlobalStyle, null), react_1.default.createElement(react_transition_group_1.SwitchTransition, Object.assign({}, switchProps), react_1.default.createElement(react_transition_group_1.CSSTransition, Object.assign({
    key: state,
    addEndListener: function addEndListener(node, done) {
      var interval = setTimeout(function () {
        done();
      }, FALLBACK_DELAY);
      node.addEventListener('transitionend', function () {
        clearTimeout(interval);
        done();
      }, false);
    },
    classNames: type,
    appear: true
  }, props), react_1.default.createElement("div", Object.assign({}, containerProps, {
    children: children
  })))));
}

exports.Transition = Transition;
exports.TransitionGlobalStyle = (0, styled_components_1.createGlobalStyle)(_templateObject());